/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AssessmentProposal from './AssessmentProposal';

/**
 * The PaginatedAssessmentProposedPropertiesResponse model module.
 * @module model/PaginatedAssessmentProposedPropertiesResponse
 * @version 1.0.0
 */
class PaginatedAssessmentProposedPropertiesResponse {
    /**
     * Constructs a new <code>PaginatedAssessmentProposedPropertiesResponse</code>.
     * @alias module:model/PaginatedAssessmentProposedPropertiesResponse
     */
    constructor() { 
        
        PaginatedAssessmentProposedPropertiesResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PaginatedAssessmentProposedPropertiesResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PaginatedAssessmentProposedPropertiesResponse} obj Optional instance to populate.
     * @return {module:model/PaginatedAssessmentProposedPropertiesResponse} The populated <code>PaginatedAssessmentProposedPropertiesResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PaginatedAssessmentProposedPropertiesResponse();

            if (data.hasOwnProperty('total_count')) {
                obj['total_count'] = ApiClient.convertToType(data['total_count'], 'Number');
            }
            if (data.hasOwnProperty('current_page')) {
                obj['current_page'] = ApiClient.convertToType(data['current_page'], 'Number');
            }
            if (data.hasOwnProperty('per_page')) {
                obj['per_page'] = ApiClient.convertToType(data['per_page'], 'Number');
            }
            if (data.hasOwnProperty('assessment_proposals')) {
                obj['assessment_proposals'] = ApiClient.convertToType(data['assessment_proposals'], [AssessmentProposal]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PaginatedAssessmentProposedPropertiesResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PaginatedAssessmentProposedPropertiesResponse</code>.
     */
    static validateJSON(data) {
        if (data['assessment_proposals']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['assessment_proposals'])) {
                throw new Error("Expected the field `assessment_proposals` to be an array in the JSON data but got " + data['assessment_proposals']);
            }
            // validate the optional field `assessment_proposals` (array)
            for (const item of data['assessment_proposals']) {
                AssessmentProposal.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * 全提案済みユニーク物件数
 * @member {Number} total_count
 */
PaginatedAssessmentProposedPropertiesResponse.prototype['total_count'] = undefined;

/**
 * 現在のページ
 * @member {Number} current_page
 */
PaginatedAssessmentProposedPropertiesResponse.prototype['current_page'] = undefined;

/**
 * 1ページあたりの件数
 * @member {Number} per_page
 */
PaginatedAssessmentProposedPropertiesResponse.prototype['per_page'] = undefined;

/**
 * @member {Array.<module:model/AssessmentProposal>} assessment_proposals
 */
PaginatedAssessmentProposedPropertiesResponse.prototype['assessment_proposals'] = undefined;






export default PaginatedAssessmentProposedPropertiesResponse;

